import { ProviderType } from '@dcl/schemas/dist/dapps/provider-type';
export function isWeb2Wallet(wallet) {
    return (wallet.providerType === ProviderType.MAGIC ||
        wallet.providerType === ProviderType.MAGIC_TEST);
}
//# sourceMappingURL=providerChecks.js.map